class ClothLibrary {
  constructor() {}

  async getCloths(options = {}) {
    const { search, page, size, composition_mapped, colour_mapped, design_mapped } = options;

    const searchParams = new URLSearchParams();

    if (search) searchParams.set('search', search);
    if (page) searchParams.set('page', page);
    if (design_mapped) searchParams.set('design_mapped', design_mapped);
    if (size) searchParams.set('size', size);
    if (composition_mapped) searchParams.set('composition_mapped', composition_mapped);
    if (colour_mapped) searchParams.set('colour_mapped', colour_mapped);

    return fetch('/apps/cloth-library/api/cloths?' + searchParams, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => response.json());
  }

  async getCloth(patternNumber) {
    return fetch(
      '/apps/cloth-library/api/cloth?' +
        new URLSearchParams({
          pattern_number: patternNumber,
        }),
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => response.json());
  }

  async getFilters() {
    return fetch('/apps/cloth-library/api/filters', {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => response.json());
  }
}

window.ClothLibrary = new ClothLibrary();
